import React from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';

type Props = {
    onChange?: (key: string) => void;
    defaultActiveKey?: string;
    activeKey?: string;
    items: TabsProps['items']
}

const TabsComp: React.FC<Props> = ({
    onChange,
    defaultActiveKey = "1",
    items = [],
    activeKey = "1"
}: Props) =>
    <Tabs
        defaultActiveKey={defaultActiveKey}
        activeKey={activeKey}
        items={items}
        onChange={onChange}
    />;

export default TabsComp;